/* Blindspot wishlist — localStorage, no apps, no accounts */
(() => {
  const KEY = 'bs-wishlist';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  };
  const write = (list) => {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('bs:wishlist', { detail: { list } }));
  };
  const toggle = (handle) => {
    const list = read();
    const i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return list.includes(handle);
  };
  window.bsWishlist = { read, toggle };

  const HEART_OUTLINE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.6C.4 8 2 4.5 5.5 4c2.1-.3 4 .8 4.9 2.4h3.2C14.5 4.8 16.4 3.7 18.5 4 22 4.5 23.6 8 22 11.4 19.5 16.1 12 21 12 21z" transform="scale(0.92) translate(1,1)"/></svg>';

  if (!customElements.get('bs-wish-toggle')) {
    customElements.define('bs-wish-toggle', class extends HTMLElement {
      connectedCallback() {
        this.handle = this.getAttribute('handle');
        this.labelAdd = this.getAttribute('label-add') || 'Save to wishlist';
        this.labelSaved = this.getAttribute('label-saved') || 'Saved to wishlist';
        this.innerHTML = '<button type="button"><span data-ico>' + HEART_OUTLINE + '</span><span data-txt></span></button>';
        this.querySelector('button').addEventListener('click', () => {
          toggle(this.handle);
          this.paint();
        });
        document.addEventListener('bs:wishlist', () => this.paint());
        this.paint();
      }
      paint() {
        const saved = read().includes(this.handle);
        this.toggleAttribute('saved', saved);
        this.querySelector('[data-txt]').textContent = saved ? this.labelSaved : this.labelAdd;
      }
    });
  }

  if (!customElements.get('bs-wish-count')) {
    customElements.define('bs-wish-count', class extends HTMLElement {
      connectedCallback() {
        this.paint();
        document.addEventListener('bs:wishlist', () => this.paint());
        window.addEventListener('storage', (e) => { if (e.key === KEY) this.paint(); });
      }
      paint() {
        const n = read().length;
        this.textContent = n > 0 ? String(n) : '';
        this.hidden = n === 0;
      }
    });
  }

  if (!customElements.get('bs-wishlist-grid')) {
    customElements.define('bs-wishlist-grid', class extends HTMLElement {
      connectedCallback() {
        this.emptyText = this.getAttribute('empty-text') || 'Nothing saved yet.';
        this.render();
        document.addEventListener('bs:wishlist', () => this.render());
      }
      async render() {
        const list = read();
        if (!list.length) {
          this.innerHTML = '<p class="bs-wishlist-empty">' + this.emptyText + '</p>';
          return;
        }
        const money = (cents) => {
          const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
          } catch { return '$' + (cents / 100).toFixed(2); }
        };
        const products = (await Promise.all(
          list.map((h) => fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null))
        )).filter(Boolean);
        const grid = document.createElement('div');
        grid.className = 'bs-wishlist-grid';
        grid.innerHTML = products.map((p) => (
          '<figure class="bs-wish-card">' +
            '<a href="' + p.url + '">' +
              (p.featured_image ? '<img src="' + p.featured_image + '&width=600" alt="">'.replace('&width', p.featured_image.includes('?') ? '&width' : '?width') : '<img alt="">') +
            '</a>' +
            '<button class="bs-wish-remove" type="button" data-handle="' + p.handle + '" aria-label="Remove">&times;</button>' +
            '<figcaption><span>' + p.title + '</span><span>' + money(p.price) + '</span></figcaption>' +
          '</figure>'
        )).join('');
        grid.addEventListener('click', (e) => {
          const b = e.target.closest('.bs-wish-remove');
          if (b) toggle(b.dataset.handle);
        });
        this.innerHTML = '';
        this.appendChild(grid);
      }
    });
  }
})();
